/* eslint-disable no-underscore-dangle */
import React from 'react';
import _ from 'lodash';

import Config from '../../utils/Configuration';
import InputBox from '../InputBox/InputBox';
import {SearchIcon} from '../../styles/icons';

export default class FibreCoverageAutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this._isMounted = false;

        this.state = {
            coverageAddressList: [],
            isLoadingAutoCompleteSuggestion: false
        };

        this.inputFocusAction = this.inputFocusAction.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.requestFibreCoverageAddressSuggestion = _.debounce(
            this.requestFibreCoverageAddressSuggestion.bind(this),
            Config.fibreCoverageAutoComplete.debouncePeriod
        );
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    // Functions -------------------------------------------------------------------------------------------------------
    customStateUpdateFunc = (args) => {
        this._isMounted && this.setState(args);
    };

    requestFibreCoverageAddressSuggestion(addressString = '') {
        const {postcode: coveragePostCode = '', state: coverageState = ''} = this.props.fibreCoverageLookupFilter || {};

        if (addressString.length >= Config.fibreCoverageAutoComplete.minSearchChar) {
            this.customStateUpdateFunc({isLoadingAutoCompleteSuggestion: true});
            const payload = _.pickBy(
                {address: addressString, postCode: coveragePostCode, state: coverageState},
                _.identity
            );
            this.props
                .fibreCoverageLookupAction(payload)
                .then((response) => {
                    const result = (response.address || []).map((item) => ({
                        id: item.addressId,
                        value: item,
                        text: item.address.replace(
                            new RegExp(`${addressString}`, 'i'),
                            (str) => `<span class="maxis-bold text-black">${str}</span>`
                        )
                    }));
                    this.customStateUpdateFunc({coverageAddressList: result});
                })
                .finally(() => {
                    this.customStateUpdateFunc({isLoadingAutoCompleteSuggestion: false});
                });
        }
    }

    inputFocusAction() {
        if (this.props.inputValue.length < Config.fibreCoverageAutoComplete.minSearchChar) {
            this.customStateUpdateFunc({coverageAddressList: []});
        }
    }

    inputChangeHandler(event) {
        this.props.onAddressInput(event.target);
        this.requestFibreCoverageAddressSuggestion(event.target.value);
    }

    // Render ----------------------------------------------------------------------------------------------------------
    render() {
        return (
            <InputBox
                inputAutoComplete='off'
                autoCompleteListClas='auto-complete-list-class'
                autoCompleteContainerClass='auto-complete-container'
                autoCompleteTextClass='auto-complete-text-class maxis'
                onFocus={this.inputFocusAction}
                inputChangeHandler={this.inputChangeHandler}
                autoComplete={{
                    showEmptyBlock: [
                        !this.state.isLoadingAutoCompleteSuggestion,
                        this.state.coverageAddressList.length === 0,
                        this.props.inputValue.length >= Config.fibreCoverageAutoComplete.minSearchChar
                    ].every(Boolean),
                    emptyAutoCompletePlaceholder: this.props.emptyAutoCompletePlaceholder,
                    autoCompleteList: this.state.coverageAddressList,
                    isLoading: this.state.isLoadingAutoCompleteSuggestion,
                    onAutoCompleteClick: this.props.onSelectAutoCompleteSuggestion,
                    autoCompleteLeadingIcon: <SearchIcon />
                }}
                {...this.props}
            />
        );
    }
}
